import { t as e } from "./AppLocales-BhP8HhaO.js";
//#region src/utils/isDefined.ts
var t = (e) => e != null, n = (e, n) => {
	if (!t(e)) throw n ?? /* @__PURE__ */ Error("Expected value to be defined");
}, r = (e, t) => {
	throw Error(t ?? `Unexpected value: ${String(e)}`);
}, i = (e) => e.length === 0 ? e : `${e.charAt(0).toUpperCase()}${e.slice(1)}`, a = (e) => e.replace(/[\\%_]/g, (e) => `\\${e}`), o = (e, n, r) => {
	let i = e.find(n);
	if (!t(i)) throw r ?? /* @__PURE__ */ Error("No item matches the predicate");
	return i;
}, s = (e) => Array.isArray(e) && e.length > 0, c = (e) => typeof e == "object" && !!e && !Array.isArray(e), l = (t) => typeof t == "string" && e.includes(t), u = (e) => {
	try {
		return JSON.parse(e);
	} catch {
		return null;
	}
}, d = (e) => Object.entries(e);
//#endregion
export { n as assertIsDefinedOrThrow, r as assertUnreachable, i as capitalize, a as escapeForIlike, o as findOrThrow, t as isDefined, s as isNonEmptyArray, c as isPlainObject, l as isValidLocale, u as parseJson, d as typedObjectEntries };

//# sourceMappingURL=utils.mjs.map